import React from 'react'
import { useRoutes, Navigate, BrowserRouter } from 'react-router-dom'

import { NavComponent } from 'components'
import { route } from 'settings'
import { general } from 'utils'
import {
  LoginPages,
  ProfilePages,
  PatientPages,
  HealthDataMange,
  AffinityPage,
} from 'pages'

function RoutePage() {
  const auth = general.auth.isAuthorized()

  const redirectCondition = (condition: boolean, children: React.ReactNode) => {
    if (condition) return children

    if (!auth) return <Navigate replace to={route.LOGIN_PAGE_URL} />
    else return <Navigate replace to={route.PATIENT_PAGE_URL} />
  }

  return useRoutes([
    {
      path: '/',
      element: <NavComponent.MainLayout />,
      children: [
        {
          path: route.LOGIN_PAGE_URL,
          element: redirectCondition(!auth, <LoginPages.Login />),
        },
        {
          path: route.PATIENT_PAGE_URL,
          children: [
            {
              path: route.PATIENT_PAGE_URL,
              element: redirectCondition(auth, <PatientPages.PatientPage />),
            },
            {
              path: route.CREATE_NEW_PATIENT,
              element: redirectCondition(
                auth,
                <PatientPages.AddPatientUserPage />,
              ),
            },
            {
              path: route.PATIENT_DATA_PAGE_URL,
              element: redirectCondition(
                auth,
                <PatientPages.EditPatientUserPage />,
              ),
            },
          ],
        },
        {
          path: route.MEDICAL_DATA_PAGE_URL,
          children: [
            {
              path: route.MEDICAL_DATA_DATA_LIST_PAGE_URL,
              element: redirectCondition(
                auth,
                <HealthDataMange.HealthDataManagementPage />,
              ),
            },
            {
              path: route.MEDICAL_DATA_CREATE_PAGE_URL,
              element: redirectCondition(
                auth,
                <HealthDataMange.AddHealthDataManagementPage />,
              ),
            },
            {
              path: route.MEDICAL_DATA_DATA_LOOKUP_PAGE_URL,
              element: redirectCondition(
                auth,
                <HealthDataMange.HealthDataPage />,
              ),
            },
          ],
        },
        {
          path: route.AFFINITY_PAGE_URL,
          children: [
            {
              path: route.AFFINITY_PAGE_URL,
              element: redirectCondition(auth, <AffinityPage.AffinityPage />),
            },
          ],
        },
        {
          path: route.SETTING_PAGE_URL,
          element: <NavComponent.UserLayout />,
          children: [
            {
              path: route.SETTING_PAGE_URL,
              element: <Navigate to={route.PROFILE_PAGE_URL} />,
            },
            {
              path: route.PROFILE_PAGE_URL,
              element: redirectCondition(
                auth,
                <ProfilePages.UserProfilePage />,
              ),
            },
            {
              path: route.CHANGE_PASSWORD_PAGE_URL,
              element: redirectCondition(
                auth,
                <ProfilePages.ChangePasswordPage />,
              ),
            },
          ],
        },
      ],
    },
    {
      path: route.EXPECT_PAGE_URL,
      element: <Navigate to={route.LOGIN_PAGE_URL} />,
    },
  ])
}

const Router = () => {
  return (
    <BrowserRouter basename={'/'}>
      <RoutePage />
    </BrowserRouter>
  )
}

export default Router
